import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  justify-content: space-between;
  align-items: center;

  ${theme.breakpoints.between("tablet", "desktop")} {
    flex-flow: column wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 14px;
`;

export const Button = styled(BaseLink)`
  display: flex;
  justify-content: center;
  align-items: center;

  padding-block: 10px;
  padding-inline: 16px;

  border-radius: 2px;

  background-color: #4585ff;

  span {
    display: block;

    margin-inline-start: 10px;

    color: #ffffff;
    line-height: 16px;
    white-space: nowrap;
  }
`;
